import React from "react";
import "../styles/views.css";

const SecondViews = () => {
  return (
    <div className=''>
      <section class='section4'>
        <div>
          <h1>Watch everywhere.</h1>
          <h2>
            Stream unlimited movies and TV shows <br />
            on your phone, tablet, laptop, and TV.
          </h2>
        </div>
      </section>
    </div>
  );
};

export default SecondViews;
